import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { Box } from '@chakra-ui/core';

import { PageIndex } from '../common/components/layouts/Page/PageIndex';
import { SearchInput } from '../common/components/Form/FormInputs';
import { SecondaryButton, PrimaryButton } from '../common/components/Buttons';
import {
  Table,
  Thead,
  TH,
  TD,
  THeadRow,
  TBodyRow,
  TablePlaceholder,
  TableEditLink,
  TableResults,
} from '../common/components/Table';
import { ergoOfficesActions } from '../redux/ergoOffices/actions';
import { Pagination } from '../common/components/Pagination';

import Can from '../roleBasedAccess/Can';

const ConnectedErgoOfficesIndex = ({ match, getErgoOffices, pending, ergoOffices, meta }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');

  useEffect(() => {
    getErgoOffices(currentPage, search);
  }, [getErgoOffices, currentPage, search]);

  return (
    <PageIndex pageAction={<Header match={match} meta={meta} onSearch={name => setSearch(name)} />}>
      <Table>
        <Thead>
          <THeadRow>
            <TH>Nom du Cabinet</TH>
            <TH>Nombre d'ergothérapeutes ({meta?.totalErgo || '0'})</TH>
          </THeadRow>
        </Thead>
        <tbody>
          {!ergoOffices || pending ? (
            <TablePlaceholder />
          ) : (
            ergoOffices.map(({ id, name, usersCount = 0 }) => (
              <TBodyRow key={id}>
                <TD>
                  <TableEditLink to={`${match.url}/${id}/edit`}>{name}</TableEditLink>
                </TD>
                <TD>
                  <TableEditLink to={`${match.url}/${id}/edit`}>{usersCount}</TableEditLink>
                </TD>
              </TBodyRow>
            ))
          )}
        </tbody>
      </Table>
      {meta && (
        <Pagination
          current={currentPage}
          total={meta.total}
          defaultPageSize={meta.perPage}
          onChange={page => setCurrentPage(page)}
        />
      )}
    </PageIndex>
  );
};

const mapStateToProps = ({ ergoOffices: state }) => ({
  pending: state.pending,
  ergoOffices: state.data,
  meta: state.meta,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getErgoOffices: ergoOfficesActions.getErgoOffices,
    },
    dispatch,
  );

export const ErgoOfficesIndex = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConnectedErgoOfficesIndex);

const SearchBar = ({ onSearch }) => {
  return (
    <Formik initialValues={{ search: '' }} onSubmit={values => onSearch(values.search)}>
      {formik => (
        <Box as="form" onSubmit={formik.handleSubmit} d="flex" alignItems="start" flexWrap="wrap">
          <SearchInput name="search" />
          <SecondaryButton type="submit" size="sm" ml={3}>
            Lancer la recherche
          </SecondaryButton>
        </Box>
      )}
    </Formik>
  );
};

const Header = ({ onSearch, match, meta }) => {
  return (
    <>
      <SearchBar onSearch={onSearch} />
      <Can
        perform="ergo-offices:create"
        yes={() => (
          <PrimaryButton as={Link} to={`${match.url}/new`} rightIcon="plus">
            Créer un cabinet
          </PrimaryButton>
        )}
      />
      {meta && <TableResults ressource="bénéficiaire" total={meta.total} />}
    </>
  );
};
